import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Home() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <i className="ri-loader-line w-8 h-8 flex items-center justify-center animate-spin text-blue-600 mx-auto mb-4"></i>
          <p className="text-gray-600">Wird geladen...</p>
        </div>
      </div>
    );
  }

  // Redirect based on authentication status
  return <Navigate to={user ? "/dashboard" : "/auth"} replace />;
}